<!--
 * @Description:: 请补充填写
 * @Version: 请配置版本号
 * @Author: xiaobai
 * @Date: 2021-06-11 15:53:04
 * @LastEditors: smallWhite
 * @LastEditTime: 2022-12-19 17:01:31
 * @FilePath: /fujian-official-website/src/views/rencaizhaopin/components/team_building.vue
-->
<template>
<div>
  <div v-if="!show"  class="mt-10 team_build_box">
    <div class="team_build_box_a">
      <img v-if="loading" class="loading_img" src="../../../assets/imgaes/loading.7.gif">
      <el-row v-else :gutter="20">
        <el-col :sm="12" :md="8" :lg="8" class="mt-20" v-for="(item,index) in teamList" :key="index">
          <div class="team_build" @click="open(item)">
            <img :src="item.imgUrl" class="team_build_img">
            <div class="img_bg">
              <div class="card_text">
                <div>{{item.name}}</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
  <!-- <Details @goback="goback" v-if="show" :details="details"></Details> -->
</div>
  
</template>

<script>
import axios from 'axios'
// import Details from './details.vue'

export default {
  // components:{Details},
  data(){
    return{
      show:false,
      loading:true,
      teamList:[],
      details:{}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    open(item){
      this.$router.push({
        path:'/team_building_details',
        query:{
          item:JSON.stringify(item)
        }
      })
      this.details = item
      this.show = true
    },
    getList() {
      this.loading = true
      const id = this.$store.state.navList[7].children[2].id
      axios.post('/home/engineering/case', {
        projectId:id
      }).then((res) => {
        this.loading = false
        this.teamList = res.data.data.resourcesDtoList
        this.teamList.map(item=>{
          this.$set(item,'imgUrl',res.data.data.imgUrl +'/'+ item.url)
        })
      })
    },
    goback(){
      this.show = false
      this.details = {}
    },
  },
}
</script>

<style>

</style>